// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__AVKHr","topBottomGutter":"Layout_topBottomGutter__36sUs"};